import { trpc } from "lib/trpc";
import { DocumentsList } from "@compass/shared/types";

export const useFileList = (input: DocumentsList) => {
    const query = trpc.userContent.list.useQuery(input, {
        placeholderData: (prev) => prev,
    });

    const { data, isInitialLoading } = query;
    const nothingFound = Boolean(
        !isInitialLoading &&
        data &&
        data.totalFound === 0 &&
        Object.keys(input).filter((key) => key !== "_empty").length,
    );

    return { ...query, nothingFound };
};
